import React from 'react'
import ReactDOM from 'react-dom'
import {Lang} from 'yougile-lang'
import {LinkButton} from '../buttons'
import {NotificationPopup} from './notification-popup'
import {useKeyboardInteraction} from './use-keyboard-interaction'

export const showAlert = async (message: string): Promise<void> =>
  new Promise(resolve => {
    const el = document.createElement('div')
    document.body.appendChild(el)

    const close = () => {
      ReactDOM.unmountComponentAtNode(el)
      document.body.removeChild(el)
      resolve()
    }

    ReactDOM.render(<Alert message={message} close={close} />, el)
  })

interface Props {
  message: string
  close(): void
}

const Alert = ({message, close}: Props) => {
  useKeyboardInteraction({close, ok: close})

  return (
    <NotificationPopup
      title={Lang.msg.common.alert}
      icon="IconAlertCircle"
      content={<div className="text-secondary">{message}</div>}
      onClose={close}
      buttons={
        <LinkButton size="small" onClick={close}>
          {Lang.msg.ok}
        </LinkButton>
      }
    />
  )
}
